import React from "react";
import PropTypes from "prop-types";
import Spinner from "../Spinner";
import FilterOut from "../NotFound/FilterOut";
import ListingPage from "../ListingPage";
import ResultsHeader from "./ResultsHeader";
import ResultsFooter from "./ResultsFooter";
import styles from "./ProductList.css";
import config from "../../config/common";
import { withTranslation } from "../translation";
import withAdverts from "../../containers/withAdverts";

const {
  api: {
    product: {
      search: { pageSize }
    }
  }
} = config;

const renderProducts = ({
  offset: { initial },
  pages,
  tileToFocus: {
    first: focusFirstTile,
    last: focusLastTile,
    pageNumber: focusPageNumber
  },
  advert
}) => {
  const focusPageIndex = focusPageNumber - pages[0].pageNumber;

  return pages.map((page, index) => (
    <ListingPage
      focusFirstTile={index === focusPageIndex && focusFirstTile}
      focusLastTile={index === focusPageIndex && focusLastTile}
      isInitialPage={(page.pageNumber - 1) * pageSize === initial}
      page={page}
      key={page.pageNumber}
      advert={advert}
    />
  ));
};

const ResultsList = ({
  isLoading,
  pages,
  offset,
  tileToFocus,
  itemCount,
  showLoadPrevious,
  showLoadMore,
  listAdvert,
  footerAdvert,
  formatTranslation
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <ResultsHeader
        showLoadPrevious={showLoadPrevious}
        itemCount={itemCount}
      />
      <div className={styles.productList} data-auto-id="productList">
        <span className={styles.srOnly} role="alert">
          {isLoading
            ? formatTranslation("generic_accessibility_loading_products")
            : ""}
        </span>
        {isLoading && (
          <div className={styles.overlay} data-auto-id="productListSpinner">
            <span className={styles.loadSpinner}>
              <Spinner size="large" />
            </span>
            <span className={styles.mask} />
          </div>
        )}
        {pages.length ? (
          renderProducts({ pages, tileToFocus, offset, advert: listAdvert })
        ) : (
          <FilterOut />
        )}
      </div>
      <ResultsFooter
        hasPages={!!pages.length}
        itemCount={itemCount}
        offset={offset}
        showLoadMore={showLoadMore}
      />
      {footerAdvert ? footerAdvert({ className: styles.advert }) : null}
    </div>
  </div>
);

ResultsList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  offset: PropTypes.object.isRequired,
  tileToFocus: PropTypes.shape({
    first: PropTypes.bool,
    last: PropTypes.bool,
    pageNumber: PropTypes.number
  }).isRequired,
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired,
  showLoadMore: PropTypes.bool.isRequired,
  listAdvert: PropTypes.func,
  footerAdvert: PropTypes.func,
  formatTranslation: PropTypes.func.isRequired
};

export default withAdverts(withTranslation(ResultsList));
